import Vue from 'vue';
import {
  BootstrapVue,
  ToastPlugin,
  ModalPlugin,
  BootstrapVueIcons,
} from 'bootstrap-vue';
import VueCompositionAPI from '@vue/composition-api';

import router from './router';
import store from './store';
import App from './App.vue';
import axios from 'axios';
import VueCurrencyFilter from 'vue-currency-filter';

// Global Components
import './global-components';

// 3rd party plugins
import '@/libs/portal-vue';
import '@/libs/toastification';
import '@/libs/sweet-alerts';
import moment from 'moment';

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

// Composition API
Vue.use(VueCompositionAPI);
Vue.use(VueCurrencyFilter, {
  symbol: '',
  thousandsSeparator: '.',
  fractionCount: 0,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true,
});

// import core styles
require('@core/scss/core.scss');

// import assets styles
require('@/assets/scss/style.scss');

Vue.prototype.$http = axios;
// Sets the default url used by all of this axios instance's requests
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;
axios.defaults.headers.get['Accept'] = 'application/json';

const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  Vue.prototype.$role = localStorage.getItem('role');
}
axios.interceptors.request.use(
  function(config) {
    store.commit('app/SET_SPINNER', true);
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  function(response) {
    store.commit('app/SET_SPINNER', false);
    return response;
  },
  function(error) {
    store.commit('app/SET_SPINNER', false);
    if (error.response.status === 401) {
      store.dispatch('user/logout');
      router.push('/login');
    }
    if (error.response.status === 422) {
      alert('Kode 422,Terjadi kesalahan sistem, silahkan coba lagi');
    }

    if (error.response.status === 500) {
      alert('Kode 500,Terjadi kesalahan sistem, silahkan coba lagi');
    }

    return Promise.reject(error);
  }
);

// 401 and 422 handle

moment.locale('id');
Vue.filter('longDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD MMMM YYYY');
  }
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
